import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAbbvieComponent } from './simple-icons-abbvie.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAbbvieComponent ],
    exports:      [ SimpleIconsAbbvieComponent ],
    bootstrap:    []
})
export class SimpleIconsAbbvieModule {}
